import { useState, useRef, useEffect } from "react";
import { toast } from 'react-hot-toast';
import { formatCurrency} from '../utils/currencyUtils';

function RowList4({data}) {
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef();
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowMenu(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const Delete = (user) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ deleteSignal: true, user: data.email })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }

    return (
        <tr className="fw-semibold">
            <td>#{data.username}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold' style={{backgroundColor:'#ffffff0d', width: '32px', height: '32px'}}>
                        <span>{data.fullname.charAt(0)}</span>
                    </div>
                    <span className='ms-2 text-nowrap'>{data.fullname}</span>
                </div>
            </td>
            <td className='text-nowrap fw-bold'>{data.signal.signal_name}</td>
            <td className='text-nowrap fw-bold'>${formatCurrency(data.signal.amount)}</td>
            <td className={`text-nowrap fw-bold ${data.signals > 50 ? 'text-success' : data.signals >= 30 ? 'text-warning' : 'text-danger'}`}>{data.signals}%</td>
            <td className="text-success fw-bold">Purchased</td>
            <td style={{ position: "relative" }}>
                <div
                className="myBtn d-inline-block px-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowMenu((prev) => !prev)}
                >
                Edit
                </div>
                {showMenu && (
                <div
                    ref={menuRef}
                    className="dropdown-menu-custom"
                    style={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    background: "#232528",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 10,
                    minWidth: "120px",
                    padding: "5px",
                    }}
                >
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Delete(data.email)}>
                    Delete
                    </div>
                </div>
                )}
            </td>
        </tr>
    )
  }
  
  export default RowList4